import { render } from "./PR53-04232026.vue?vue&type=template&id=2d4db456"
import script from "./PR53-04232026.vue?vue&type=script&lang=js"
export * from "./PR53-04232026.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__